// App.js
import React, { useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

import Navigation from './components/Navigation';
import Header from './components/Header';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Services from "./components/Services";
import Modals from './components/Modals';

import HealthDemoSection from "./components/HealthDemoSection";
import EngagementOptions from "./components/EngagementOptions";
import SystemsSection from "./components/SystemsSection";
import OperationalApproach from "./components/OperationalApproach";
import ProofSection from "./components/ProofSection";

function getCountryFromLocale() {
    try {
        const locale =
            navigator.languages?.[0] ||
            navigator.language ||
            Intl.DateTimeFormat().resolvedOptions().locale ||
            "";
        const m = locale.replace("_", "-").match(/-([A-Za-z]{2})\b/);
        return m ? m[1].toUpperCase() : "XX";
    } catch {
        return "XX";
    }
}

export function useDailyVisitPixel(pixelPath = "/img/pix.png") {
    useEffect(() => {
        try {
            if (localStorage.getItem("stats_opt_out") === "1") return;

            const today = new Date().toISOString().slice(0, 10); // YYYY-MM-DD
            const storageKey = "visit_pixel_last_day";

            const lastDay = localStorage.getItem(storageKey);
            if (lastDay === today) return; // already counted today on this browser

            // mark as counted BEFORE sending (prevents double count on quick reloads)
            localStorage.setItem(storageKey, today);

            const c = getCountryFromLocale();
            const r = Math.random().toString(36).slice(2);

            // fire-and-forget pixel
            const img = new Image();
            img.referrerPolicy = "no-referrer";
            img.src = `${pixelPath}?d=${encodeURIComponent(today)}&c=${encodeURIComponent(c)}&t=human&js=1&r=${r}`;
        } catch {
            // If localStorage is blocked, do nothing (privacy-friendly fallback)
        }
    }, [pixelPath]);
}

function App() {

    useDailyVisitPixel("/img/pix.png");

    useEffect(() => {
        const container = document.getElementById('scroll-container');
        if (!container) return;

        const sections = Array.from(document.querySelectorAll("section[id], header[id], footer[id]"));
        const navLinks = document.querySelectorAll(".navbar-nav .nav-link");

        const handleScroll = () => {
            let current = '';
            let minTop = Infinity;

            for (const section of sections) {
                const id = section.getAttribute('id');
                const rect = section.getBoundingClientRect();
                const top = rect.top;

                if (rect.bottom > 80 && top >= 0 && top < minTop) {
                    current = id;
                    minTop = top;
                }
            }

            // force 'about' if near top
            if (container.scrollTop < 200) {
                current = 'about';
            }

            // force 'legalnotice' if at bottom
            const atBottom =
                Math.ceil(container.scrollTop + container.clientHeight) >= container.scrollHeight;
            if (atBottom) {
                current = 'legalnotice';
            }

            navLinks.forEach(link => {
                link.classList.remove("active");
                if (link.dataset.target === current) {
                    link.classList.add("active");
                }
            });
        };

        container.addEventListener('scroll', handleScroll);
        setTimeout(() => handleScroll(), 100); // run on mount

        return () => container.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div id="page-top" className="index">
            <div id="scroll-container" style={{ overflowY: "auto", height: "100vh" }}>
                <Navigation />
                <Header />
                <HealthDemoSection />
                <EngagementOptions />
                <SystemsSection />
                <OperationalApproach />
                <ProofSection />
      <Contact />
                <Footer />
            </div>
        </div>
    );
}

export default App;